import { createUseStyles } from 'react-jss';
import { Timings } from '../../../../foundation/timings/timings/index.js';
import { Easing } from '../../../../foundation/easing/easing/index.js';
import { BackgroundColors } from '../../../../foundation/colors/backgroundColors/backgroundColors/index.js';
import { isRightToLeft, isLeftToRight } from '../../../../foundation/styleHelpers/rtl/rtl/index.js';
import { BreakPointsMedia } from '../../../../foundation/responsive/responsive/index.js';

const useStyles = createUseStyles({
    '@keyframes skeletonLTR': {
        '0%': {
            transform: 'translate(-200%, -50%)',
        },
        '100%': {
            transform: 'translate(100%, -50%)',
        },
    },
    '@keyframes skeletonRTL': {
        '0%': {
            transform: 'translate(100%, -50%)',
        },
        '100%': {
            transform: 'translate(-200%, -50%)',
        },
    },
    root: {
        display: 'block',
        width: ({ widths }) => widths?.Default.value,
        height: ({ heights }) => heights?.Default.value,
        borderRadius: ({ radii }) => radii?.Default.value,
        backgroundColor: BackgroundColors.tint2,
        position: 'relative',
        overflow: 'hidden',
        clipPath: 'view-box',
        [BreakPointsMedia.XXL]: {
            width: ({ widths }) => widths?.XXL.value,
            height: ({ heights }) => heights?.XXL.value,
            borderRadius: ({ radii }) => radii?.XXL.value,
        },
        [BreakPointsMedia.XL]: {
            width: ({ widths }) => widths?.XL.value,
            height: ({ heights }) => heights?.XL.value,
            borderRadius: ({ radii }) => radii?.XL.value,
        },
        [BreakPointsMedia.LG]: {
            width: ({ widths }) => widths?.LG.value,
            height: ({ heights }) => heights?.LG.value,
            borderRadius: ({ radii }) => radii?.LG.value,
        },
        [BreakPointsMedia.MD]: {
            width: ({ widths }) => widths?.MD.value,
            height: ({ heights }) => heights?.MD.value,
            borderRadius: ({ radii }) => radii?.MD.value,
        },
        [BreakPointsMedia.SM]: {
            width: ({ widths }) => widths?.SM.value,
            height: ({ heights }) => heights?.SM.value,
            borderRadius: ({ radii }) => radii?.SM.value,
        },
        [BreakPointsMedia.XS]: {
            width: ({ widths }) => widths?.XS.value,
            height: ({ heights }) => heights?.XS.value,
            borderRadius: ({ radii }) => radii?.XS.value,
        },
        [BreakPointsMedia.XXS]: {
            width: ({ widths }) => widths?.XXS.value,
            height: ({ heights }) => heights?.XXS.value,
            borderRadius: ({ radii }) => radii?.XXS.value,
        },
        '&:before': {
            content: '""',
            display: 'block',
            width: '50%',
            height: '100%',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            backgroundImage: `linear-gradient(90deg, transparent, ${BackgroundColors.tint3}, transparent)`,
            willChange: 'transform',
            [isLeftToRight]: {
                animation: `$skeletonLTR ${Timings.long} ${Easing.linear} infinite`,
            },
            [isRightToLeft]: {
                animation: `$skeletonRTL ${Timings.long} ${Easing.linear} infinite`,
            },
        },
    },
}, {
    name: 'skeleton',
});

export { useStyles };
